import "./App.css";
import "bootstrap/dist/css/bootstrap.css";
import Weather from "./Weather";

export default function App() {
  return (
    <div className="App">
      <div className="container mt-4">
        <Weather defaultCity="Kyiv" />
        <footer>
          This project was coded by Daria Butkevych and is{" "}
          <a
            className="App-link"
            href="https://github.com/Butkevych/react-weather-app"
            target="_blank"
            rel="noreferrer"
          >
            open-sourced on GitHub
          </a>
        </footer>
      </div>
    </div>
  );
}
